import React, { useState } from 'react'
import { dueDateCalculatorPath } from 'lib/urls'
import { InfoButton } from 'components/buttons'
import { DatePickerInput } from 'components/forms'
import { isValid, startOfToday, sub } from 'date-fns'
import { AdoptionIcon as CalendarIcon } from 'baby-ui/foundation/BabylistIcons'
import OptionSelect from './components/optionSelect'
import { METHOD_OPTIONS } from './constants'
import classNames from './due-date-form.scss'
import {
  getDueDateFromLastPeriod,
  getDueDateFromConceptionDate,
  formatDueDate,
} from './helpers'
import { SectionHeading } from '../../../components/headings'

const lastPeriodState = {
  datepickerLabel: 'First Day of Last Period',
  dueDateAlgorithm: getDueDateFromLastPeriod,
  methodSelected: METHOD_OPTIONS.LAST_PERIOD,
}

const conceptionDateState = {
  datepickerLabel: 'Date of Conception',
  dueDateAlgorithm: getDueDateFromConceptionDate,
  methodSelected: METHOD_OPTIONS.CONCEPTION_DATE,
}

const initialDate = sub(startOfToday(), { weeks: 2 })

const DueDateForm = ({ history }) => {
  const [{ methodSelected, datepickerLabel, dueDateAlgorithm }, setState] =
    useState(lastPeriodState)

  const handleSubmit = (e) => {
    e.preventDefault()
    const startDate = new Date(e.target.startDate.value)
    if (!isValid(startDate)) return
    const dueDate = dueDateAlgorithm(startDate)
    const resultsUrl = `${dueDateCalculatorPath}/${formatDueDate(dueDate)}`
    history.push(resultsUrl)
  }

  const handleSelection = (selection) => {
    const newState =
      selection === METHOD_OPTIONS.LAST_PERIOD
        ? lastPeriodState
        : conceptionDateState
    setState(newState)
  }

  return (
    <div className={classNames['due-date-form']}>
      <CalendarIcon />
      <SectionHeading>Due Date Calculator</SectionHeading>
      <p>When's the big day? Find out now using one of these methods:</p>
      <OptionSelect
        currentSelection={methodSelected}
        handleSelection={handleSelection}
      />
      <form onSubmit={handleSubmit}>
        <label htmlFor="startDate">{datepickerLabel}</label>
        <DatePickerInput initialValue={initialDate} name="startDate" />
        <InfoButton pill type="submit">
          Calculate Due Date
        </InfoButton>
      </form>
    </div>
  )
}

export default DueDateForm
